import React from "react";
import { capitalize } from "../../utils/wordUtils";

type ThemeType = "light" | "dark";

export type ChartCardProps = {
  className?: string;
  title?: string;
  subtitle?: string;
  theme?: ThemeType;
  children?: React.ReactNode;
  hover?: boolean;
};

export const defaultProps: ChartCardProps = {
  className: "",
  title: "Overview",
  subtitle: "Insight",
  theme: "light",
  hover: true,
};

const ChartCard = ({
  className,
  children,
  title,
  subtitle: type,
  theme,
  hover,
}: ChartCardProps): JSX.Element => {
  return (
    <div
      className={`relative w-full h-full ${className} shadow-lg ${
        hover && "hover:scale-105"
      } z-10 rounded-lg`}
    >
      <div
        className={`relative flex flex-col min-w-0 break-words w-full h-full mb-6 shadow-lg rounded ${
          theme === "light" ? "bg-white" : "bg-blueGray-700"
        }`}
      >
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h6
                className={`${
                  theme === "light" ? "text-slate-400" : "text-slate-300"
                } uppercase mb-1 text-xs font-semibold`}
              >
                {type}
              </h6>
              <h2
                className={`${
                  theme === "light" ? "text-slate-600" : "text-white"
                } text-xl font-semibold`}
              >
                {capitalize(title || "Overview")}
              </h2>
            </div>
          </div>
        </div>
        <div className="p-4 flex-auto h-full">
          {/* Chart */}
          <div className="relative h-full w-full">{children}</div>
        </div>
      </div>
    </div>
  );
};

ChartCard.defaultProps = defaultProps;

export default ChartCard;
